module.exports = __webpack_public_path__ + "static/img/baat_iv_reward_top_dialog_bg_new.ec90969.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bdm/baat_iv_reward_top_dialog_bg_new.png
// module id = 1Tf/
// module chunks = 0